import { FunctionComponent } from "react";

import { DeviceType } from "@tether-web-portal/types/DeviceType";
import { formatDeviceName } from "@tether-web-portal/utils/formatDeviceName";
import { useDeviceCatalog } from "@tether-web-portal/api/catalog/hooks";

// Device icons are served from the device-icon CDN, resolved by the catalog iconKey. Overridable via
// env (matching the VITE_*_HOST pattern) so non-prod can point at a different CDN; defaults to prod.
const ICON_BASE_URL = import.meta.env.VITE_DEVICE_ICON_CDN_URL ?? "https://assets.tetherhq.com";
const UNKNOWN_ICON_URL = `${ICON_BASE_URL}/unknown.svg`;

interface DeviceIconProps {
  type?: string;
  size?: number;
}

export const DeviceIcon: FunctionComponent<DeviceIconProps> = ({ type, size = 40 }: DeviceIconProps) => {
  const catalog = useDeviceCatalog();

  const deviceType = type?.toUpperCase() as DeviceType | undefined;
  const capability = deviceType ? catalog[deviceType] : undefined;
  // Types not in the catalog (or before it has loaded) fall back to the unknown icon.
  const iconUrl = capability?.iconKey ? `${ICON_BASE_URL}/${capability.iconKey}` : UNKNOWN_ICON_URL;
  const deviceName = capability?.displayName ?? (!type ? "Device not found" : formatDeviceName(type));

  return <img style={{ width: size }} src={iconUrl} alt={deviceName} />;
};
